import styled from 'styled-components';
import { media } from 'styles/Mixins';
import * as Layout from 'styles/Layout';

export const StepperContentWrapper = styled(Layout.FlexColumn)`
  width: 100%;
  margin: 0;
  padding: 60px 0 10px;
  ${media.md`
    padding: 60px 0 10px 40px;
    flex-direction: row;
  `}
`;
export const StepperContent = styled.div`
  width: 100%;
  border-radius: 0;
  background-color: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0);
  padding: 15px;
  ${media.md`
    ${props => !props.fullWidth && 'width: 622px'};
  `}
  ${media.sm`
    border-radius: 2px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  `}
  &.hidden {
    visibility: hidden;
    opacity: 0;
    transition: visibility 0s linear 0.2s, opacity 0.2s;
  }
  &.visible {
    visibility: visible;
    opacity: 1;
    transition: visibility 0s linear 0s, opacity 0.2s;
  }
`;

export const WrapperSpinner = styled.div`
  width: 100vh;
  height: 100vh;
  display: flex;
  align-items: center;
`;
